module.exports = __webpack_public_path__ + "img/pagina-nao-encontrada.a5313621.svg";